import {
    Component, Prop, Mixins,
} from 'vue-property-decorator';

interface service {
    name: string,
    api: string,
}

@Component
/**
 * ProfileChangePassword Props
 */
export default class Props extends Mixins() {
    /**
     * Classes
     */
    @Prop() classes!: string | Array<string>;

    /**
     * Title of the Panel
     */
    @Prop() title!: string;

    /**
     * Change Password Form Config Service
     */
    @Prop({ default: () => ({ name: 'Person', api: 'changePasswordForm' }) }) formService!: service;

    /**
     * Change Password Service
     */
    @Prop({ default: () => ({ name: 'Person', api: 'changePassword' }) }) changePasswordService!: service;

    /**
     * Success Message
     */
    @Prop() successMessage!: string;
}
